<template>
  <c-select
    title="ЯДРО:"
    form-group
    form-group-margin-bottom
    :options="getCoresListOfSelectedRegion"
    :label-width="labelWidth"
    :select-width="selectWidth"
    :value="selectedProjectId"
    :disabled="Object.keys(getCoresListOfSelectedRegion).length === 1"
    @input="changeSelectedProjectId($event)"
  />
</template>

<script>
import CSelect from '../../../../../../resources/js/components/ui/CSelect.vue'
import { mapGetters, mapState, mapActions } from 'vuex'

/**
 * Выпадающий список ядер для выбранного региона.
 */
export default {
  name: 'ClientProjectsCoreSelect',
  components: {
    CSelect
  },
  props: {
    labelWidth: {
      type: String,
      default: null
    },
    selectWidth: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      getCoresListOfSelectedRegion: 'seo/client/projects/getCoresListOfSelectedRegion'
    }),
    ...mapState({
      selectedProjectId: state => state.seo.client.projects.selectedProjectId
    })
  },
  methods: {
    ...mapActions({
      changeSelectedProjectId: 'seo/client/projects/changeSelectedProjectId'
    })
  }
}
</script>
